var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudBackupService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1139.03 1316.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e76e6;}.cls-2{fill:none;stroke:#2e76e6;stroke-linejoin:round;stroke-width:0.87px;}.cls-3{fill:#aae0ff;}.cls-4{fill:#1b57b3;}.cls-5{fill:#408bff;}.cls-6{fill:#265399;}.cls-7{fill:#246ad6;}.cls-8{fill:#2d76e6;}.cls-9{fill:#0b254d;}.cls-10{fill:#113873;}.cls-11{fill:#1951a6;}.cls-12{fill:#007880;}.cls-13{fill:#fff;}.cls-14{fill:#00c0cc;}.cls-15{fill:#2984cc;}.cls-16{fill:#2e5b99;}.cls-17{fill:#e6f6ff;}.cls-18{fill:#2370e6;}.cls-19{fill:#518ce6;}.cls-20{fill:#66a1ff;}.cls-21{fill:#80b1ff;}.cls-22{fill:#2475f2;}.cls-23,.cls-27{fill:#33b6ff;}.cls-24{fill:#15458c;}.cls-25{fill:#113773;}.cls-26{fill:#051226;}.cls-27{opacity:0.3;}.cls-28{fill:#2069d9;}.cls-29{fill:#4dbeff;}.cls-30{fill:#0d192b;}.cls-31{fill:#f7b28a;}.cls-32{fill:#b3d7ff;}.cls-33{fill:#005359;}.cls-34{fill:#854500;}.cls-35{fill:#003c40;}.cls-36{fill:#d9790d;}.cls-37{fill:#ff9117;}.cls-38{fill:#1e62cc;}.cls-39{fill:#ffca59;}.cls-40{fill:#0e0e0e;}.cls-41{fill:#ed5a24;}.cls-42{fill:#5896fa;}.cls-43{fill:#ffb900;}.cls-44{fill:#f7a58e;}.cls-45{fill:#e6856a;}.cls-46{fill:#a85900;}.cls-47{fill:#2e97e6;}.cls-48{fill:#3397ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustrator"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.15,201.47a39,39,0,0,0-9.94-11.81l1-1.26,2-2.48,0,0a43.86,43.86,0,0,0-15.14-7.84l-1.34,4.62a39.09,39.09,0,0,0-15.39-1.31l-.54-4.78a43.5,43.5,0,0,0-16.26,5.15l2.32,4.23A39,39,0,0,0,276,195.91l-3.77-3a44.09,44.09,0,0,0-7.83,15.14l4.61,1.34a39.1,39.1,0,0,0-1.3,15.39l-4.79.54a43.64,43.64,0,0,0,5.16,16.26l4.23-2.32a39.07,39.07,0,0,0,9.94,11.81l-2.12,2.66-.86,1.1h0a43.92,43.92,0,0,0,15.14,7.83l1.34-4.61a39.13,39.13,0,0,0,15.4,1.3l.54,4.78A43.47,43.47,0,0,0,328,259l-2.32-4.22a39.09,39.09,0,0,0,11.83-10l2.93,2.33.84.67a44.11,44.11,0,0,0,7.82-15.13l-4.61-1.35a39.74,39.74,0,0,0,1.31-15.41l4.78-.54a43.68,43.68,0,0,0-5.16-16.23ZM317,239.05a21.31,21.31,0,1,1,8.41-28.94A21.3,21.3,0,0,1,317,239.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.71,137.14a16.42,16.42,0,0,0-5.53-3.34l.22-.63.45-1.25v0a18.36,18.36,0,0,0-7.06-1.07l.09,2a16.4,16.4,0,0,0-6.27,1.55l-.86-1.82A18,18,0,0,0,264,136.8l1.49,1.36a16.29,16.29,0,0,0-3.35,5.53l-1.9-.68a18.5,18.5,0,0,0-1.07,7.05l2-.09a16.45,16.45,0,0,0,1.55,6.28l-1.82.86a18.25,18.25,0,0,0,4.23,5.75l1.36-1.49a16.26,16.26,0,0,0,5.53,3.34l-.48,1.35-.2.54h0a18.34,18.34,0,0,0,7.05,1.07l-.08-2a16.4,16.4,0,0,0,6.27-1.55l.86,1.82a18.41,18.41,0,0,0,5.75-4.22l-1.49-1.37a16.2,16.2,0,0,0,3.35-5.53l1.47.53.43.15a18.3,18.3,0,0,0,1.06-7.05l-2,.09a16.5,16.5,0,0,0-1.55-6.29l1.83-.85a18.41,18.41,0,0,0-4.23-5.74Zm-4.52,18.14a8.92,8.92,0,1,1-.56-12.6A8.92,8.92,0,0,1,284.19,155.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 272.03,
    y: 216.07,
    width: 575.96,
    height: 162.8,
    rx: 81.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 632,
    cy: 185.54,
    r: 127.29,
    transform: "translate(53.91 501.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 458.06,
    cy: 192.45,
    r: 85.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 389.59,
    y: 36.24,
    width: 27.28,
    height: 209.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 313.64,
    y: 36.26,
    width: 76.14,
    height: 209.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 318.8,
    y: 66.56,
    width: 65.81,
    height: 166.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.26,136.64h0a1.12,1.12,0,0,1-1.12-1.12V117.06a1.12,1.12,0,0,1,1.12-1.12h0a1.12,1.12,0,0,1,1.12,1.12v18.46A1.12,1.12,0,0,1,316.26,136.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 387.33,
    y: 82.84,
    width: 2.45,
    height: 13.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 387.33,
    y: 198.19,
    width: 2.45,
    height: 13.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 321.46,
    y: 92.62,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 321.46,
    y: 116.16,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 321.46,
    y: 139.71,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 321.46,
    y: 163.26,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 321.46,
    y: 186.8,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 321.46,
    y: 210.35,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 321.46,
    y: 69.07,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 326.44,
    y: 74.33,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.5,
    y: 77.08,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M368.58,79.38a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,368.58,79.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372,79.38a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,372,79.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.33,79.38a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,375.33,79.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 326.44,
    y: 98.14,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.5,
    y: 100.89,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 326.44,
    y: 121.95,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.5,
    y: 124.7,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 326.44,
    y: 145.75,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.5,
    y: 148.51,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 326.44,
    y: 168.94,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.5,
    y: 171.69,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 367.41,
    cy: 174.09,
    rx: 1.17,
    ry: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372,174.09a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,372,174.09Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 374.16,
    cy: 174.09,
    rx: 1.17,
    ry: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 326.44,
    y: 192.84,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.5,
    y: 195.59,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 326.44,
    y: 216.2,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.5,
    y: 218.95,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 367.41,
    cy: 221.4,
    rx: 1.17,
    ry: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372,221.4a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,372,221.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 374.16,
    cy: 221.4,
    rx: 1.17,
    ry: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M368.58,103.39a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,368.58,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372,103.39a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,372,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.33,103.39a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,375.33,103.39Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 367.41,
    cy: 126.94,
    rx: 1.17,
    ry: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372,126.94a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,372,126.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 374.16,
    cy: 126.94,
    rx: 1.17,
    ry: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M368.58,150.88a1.17,1.17,0,1,1-1.17-1.22A1.2,1.2,0,0,1,368.58,150.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372,150.88a1.17,1.17,0,1,1-1.17-1.22A1.2,1.2,0,0,1,372,150.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.33,150.88a1.17,1.17,0,1,1-1.17-1.22A1.2,1.2,0,0,1,375.33,150.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M368.58,198a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,368.58,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372,198a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,372,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.33,198a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,375.33,198Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 389.59,
    y: 36.24,
    width: 2.03,
    height: 209.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "391.78 246.14 391.46 246.14 391.46 63.73 313.71 63.73 313.71 63.41 391.78 63.41 391.78 246.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 387.33,
    y: 138.51,
    width: 2.45,
    height: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "348.93 43.74 320.94 43.74 318.78 41.65 348.93 41.65 348.93 43.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "348.93 46.89 320.94 46.89 318.78 44.8 348.93 44.8 348.93 46.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "348.93 50.05 320.94 50.05 318.78 47.96 348.93 47.96 348.93 50.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "348.93 53.2 320.94 53.2 318.78 51.11 348.93 51.11 348.93 53.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "348.93 56.35 320.94 56.35 318.78 54.26 348.93 54.26 348.93 56.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "348.93 59.51 320.94 59.51 318.78 57.42 348.93 57.42 348.93 59.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "384.17 43.74 356.18 43.74 354.02 41.65 384.17 41.65 384.17 43.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "384.17 46.89 356.18 46.89 354.02 44.8 384.17 44.8 384.17 46.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "384.17 50.05 356.18 50.05 354.02 47.96 384.17 47.96 384.17 50.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "384.17 53.2 356.18 53.2 354.02 51.11 384.17 51.11 384.17 53.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "384.17 56.35 356.18 56.35 354.02 54.26 384.17 54.26 384.17 56.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "384.17 59.51 356.18 59.51 354.02 57.42 384.17 57.42 384.17 59.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414,79.49H394.77V66.67H414Zm-19-.21h18.83V66.88H395Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414,97.26H394.77V84.44H414Zm-19-.21h18.83V84.65H395Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414,116H394.77V103.12H414Zm-19-.22h18.83V103.34H395Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414,133.72H394.77V120.9H414Zm-19-.21h18.83v-12.4H395Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414,232.53H394.77v-92H414Zm-19-.22h18.83V140.75H395Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 329.5,
    y: 246.17,
    width: 90.01,
    height: 26.73,
    rx: 1.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M392.79,246.07l-81.3.1a2.46,2.46,0,0,0-2.47,2.44v21.86a2.45,2.45,0,0,0,2.47,2.44c13.47,0,65.69.18,81.3.21a2.45,2.45,0,0,0,2.49-2.44V248.51A2.46,2.46,0,0,0,392.79,246.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 313.6,
    y: 245.69,
    width: 103.32,
    height: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M336,253H314.45a1.74,1.74,0,0,1-1.74-1.74h0a1.74,1.74,0,0,1,1.74-1.75H336a1.75,1.75,0,0,1,1.75,1.75h0A1.75,1.75,0,0,1,336,253Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 500.22,
    y: 36.24,
    width: 27.28,
    height: 209.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 424.27,
    y: 36.26,
    width: 76.14,
    height: 209.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 429.43,
    y: 66.56,
    width: 65.81,
    height: 166.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M426.89,136.64h0a1.12,1.12,0,0,1-1.12-1.12V117.06a1.12,1.12,0,0,1,1.12-1.12h0a1.12,1.12,0,0,1,1.12,1.12v18.46A1.12,1.12,0,0,1,426.89,136.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 497.95,
    y: 82.84,
    width: 2.45,
    height: 13.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 497.95,
    y: 198.19,
    width: 2.45,
    height: 13.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 432.08,
    y: 92.62,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 432.08,
    y: 116.16,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 432.08,
    y: 139.71,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 432.08,
    y: 163.26,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 432.08,
    y: 186.8,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 432.08,
    y: 210.35,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 432.08,
    y: 69.07,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 437.06,
    y: 74.33,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 439.12,
    y: 77.08,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.21,79.38A1.17,1.17,0,1,1,478,78.15,1.2,1.2,0,0,1,479.21,79.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M482.58,79.38a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,482.58,79.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M486,79.38a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,486,79.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 437.06,
    y: 98.14,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 439.12,
    y: 100.89,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 437.06,
    y: 121.95,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 439.12,
    y: 124.7,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 437.06,
    y: 145.75,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 439.12,
    y: 148.51,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 437.06,
    y: 168.94,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 439.12,
    y: 171.69,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.21,174.09a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,479.21,174.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M482.58,174.09a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,482.58,174.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M486,174.09a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,486,174.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 437.06,
    y: 192.84,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 439.12,
    y: 195.59,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 437.06,
    y: 216.2,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 439.12,
    y: 218.95,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.21,221.4a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,479.21,221.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M482.58,221.4a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,482.58,221.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M486,221.4a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,486,221.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.21,103.39a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,479.21,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M482.58,103.39a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,482.58,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M486,103.39a1.17,1.17,0,1,1-1.16-1.23A1.19,1.19,0,0,1,486,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.21,126.94a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,479.21,126.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M482.58,126.94a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,482.58,126.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M486,126.94a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,486,126.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.21,150.88a1.17,1.17,0,1,1-1.17-1.22A1.2,1.2,0,0,1,479.21,150.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M482.58,150.88a1.17,1.17,0,1,1-1.17-1.22A1.2,1.2,0,0,1,482.58,150.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M486,150.88a1.17,1.17,0,1,1-1.16-1.22A1.2,1.2,0,0,1,486,150.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.21,198a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,479.21,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M482.58,198a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,482.58,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M486,198a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,486,198Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 500.22,
    y: 36.24,
    width: 2.03,
    height: 209.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "502.41 246.14 502.09 246.14 502.09 63.73 424.33 63.73 424.33 63.41 502.41 63.41 502.41 246.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 497.95,
    y: 138.51,
    width: 2.45,
    height: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "459.55 43.74 431.57 43.74 429.4 41.65 459.55 41.65 459.55 43.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "459.55 46.89 431.57 46.89 429.4 44.8 459.55 44.8 459.55 46.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "459.55 50.05 431.57 50.05 429.4 47.96 459.55 47.96 459.55 50.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "459.55 53.2 431.57 53.2 429.4 51.11 459.55 51.11 459.55 53.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "459.55 56.35 431.57 56.35 429.4 54.26 459.55 54.26 459.55 56.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "459.55 59.51 431.57 59.51 429.4 57.42 459.55 57.42 459.55 59.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "494.8 43.74 466.81 43.74 464.65 41.65 494.8 41.65 494.8 43.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "494.8 46.89 466.81 46.89 464.65 44.8 494.8 44.8 494.8 46.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "494.8 50.05 466.81 50.05 464.65 47.96 494.8 47.96 494.8 50.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "494.8 53.2 466.81 53.2 464.65 51.11 494.8 51.11 494.8 53.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "494.8 56.35 466.81 56.35 464.65 54.26 494.8 54.26 494.8 56.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "494.8 59.51 466.81 59.51 464.65 57.42 494.8 57.42 494.8 59.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M524.66,79.49H505.4V66.67h19.26Zm-19-.21h18.83V66.88H505.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M524.66,97.26H505.4V84.44h19.26Zm-19-.21h18.83V84.65H505.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M524.66,116H505.4V103.12h19.26Zm-19-.22h18.83V103.34H505.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M524.66,133.72H505.4V120.9h19.26Zm-19-.21h18.83v-12.4H505.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M524.66,232.53H505.4v-92h19.26Zm-19-.22h18.83V140.75H505.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 440.12,
    y: 246.17,
    width: 90.01,
    height: 26.73,
    rx: 1.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M503.42,246.07l-81.3.1a2.45,2.45,0,0,0-2.47,2.44v21.86a2.44,2.44,0,0,0,2.47,2.44c13.47,0,65.69.18,81.3.21a2.45,2.45,0,0,0,2.48-2.44V248.51A2.45,2.45,0,0,0,503.42,246.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 424.23,
    y: 245.69,
    width: 103.32,
    height: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M446.64,253H425.08a1.75,1.75,0,0,1-1.75-1.74h0a1.75,1.75,0,0,1,1.75-1.75h21.56a1.75,1.75,0,0,1,1.75,1.75h0A1.75,1.75,0,0,1,446.64,253Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 613.22,
    y: 36.24,
    width: 27.28,
    height: 209.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 537.27,
    y: 36.26,
    width: 76.14,
    height: 209.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 542.43,
    y: 66.56,
    width: 65.81,
    height: 166.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M539.89,136.64h0a1.12,1.12,0,0,1-1.12-1.12V117.06a1.12,1.12,0,0,1,1.12-1.12h0a1.12,1.12,0,0,1,1.12,1.12v18.46A1.12,1.12,0,0,1,539.89,136.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 610.96,
    y: 82.84,
    width: 2.45,
    height: 13.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 610.96,
    y: 198.19,
    width: 2.45,
    height: 13.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 545.09,
    y: 92.62,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 545.09,
    y: 116.16,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 545.09,
    y: 139.71,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 545.09,
    y: 163.26,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 545.09,
    y: 186.8,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 545.09,
    y: 210.35,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 545.09,
    y: 69.07,
    width: 61.58,
    height: 20.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 550.07,
    y: 74.33,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 552.13,
    y: 77.08,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592.21,79.38A1.17,1.17,0,1,1,591,78.15,1.2,1.2,0,0,1,592.21,79.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M595.58,79.38a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,595.58,79.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599,79.38a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,599,79.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 550.07,
    y: 98.14,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 552.13,
    y: 100.89,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 550.07,
    y: 121.95,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 552.13,
    y: 124.7,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 550.07,
    y: 145.75,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 552.13,
    y: 148.51,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 550.07,
    y: 168.94,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 552.13,
    y: 171.69,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592.21,174.09a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,592.21,174.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M595.58,174.09a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,595.58,174.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599,174.09a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,599,174.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 550.07,
    y: 192.84,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 552.13,
    y: 195.59,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 550.07,
    y: 216.2,
    width: 50.76,
    height: 10.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 552.13,
    y: 218.95,
    width: 36.4,
    height: 4.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592.21,221.4a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,592.21,221.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M595.58,221.4a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,595.58,221.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599,221.4a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,599,221.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592.21,103.39a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,592.21,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M595.58,103.39a1.17,1.17,0,1,1-1.16-1.23A1.19,1.19,0,0,1,595.58,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599,103.39a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,599,103.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592.21,126.94a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,592.21,126.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M595.58,126.94a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,595.58,126.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599,126.94a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,599,126.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592.21,150.88a1.17,1.17,0,1,1-1.17-1.22A1.2,1.2,0,0,1,592.21,150.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M595.58,150.88a1.17,1.17,0,1,1-1.16-1.22A1.2,1.2,0,0,1,595.58,150.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599,150.88a1.17,1.17,0,1,1-1.17-1.22A1.2,1.2,0,0,1,599,150.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M592.21,198a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,592.21,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M595.58,198a1.17,1.17,0,1,1-1.16-1.23A1.2,1.2,0,0,1,595.58,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M599,198a1.17,1.17,0,1,1-1.17-1.23A1.2,1.2,0,0,1,599,198Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 613.22,
    y: 36.24,
    width: 2.03,
    height: 209.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "615.41 246.14 615.09 246.14 615.09 63.73 537.34 63.73 537.34 63.41 615.41 63.41 615.41 246.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 610.96,
    y: 138.51,
    width: 2.45,
    height: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "572.56 43.74 544.57 43.74 542.41 41.65 572.56 41.65 572.56 43.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "572.56 46.89 544.57 46.89 542.41 44.8 572.56 44.8 572.56 46.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "572.56 50.05 544.57 50.05 542.41 47.96 572.56 47.96 572.56 50.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "572.56 53.2 544.57 53.2 542.41 51.11 572.56 51.11 572.56 53.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "572.56 56.35 544.57 56.35 542.41 54.26 572.56 54.26 572.56 56.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "572.56 59.51 544.57 59.51 542.41 57.42 572.56 57.42 572.56 59.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "607.8 43.74 579.81 43.74 577.65 41.65 607.8 41.65 607.8 43.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "607.8 46.89 579.81 46.89 577.65 44.8 607.8 44.8 607.8 46.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "607.8 50.05 579.81 50.05 577.65 47.96 607.8 47.96 607.8 50.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "607.8 53.2 579.81 53.2 577.65 51.11 607.8 51.11 607.8 53.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "607.8 56.35 579.81 56.35 577.65 54.26 607.8 54.26 607.8 56.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "607.8 59.51 579.81 59.51 577.65 57.42 607.8 57.42 607.8 59.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M637.66,79.49H618.4V66.67h19.26Zm-19-.21h18.83V66.88H618.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M637.66,97.26H618.4V84.44h19.26Zm-19-.21h18.83V84.65H618.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M637.66,116H618.4V103.12h19.26Zm-19-.22h18.83V103.34H618.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M637.66,133.72H618.4V120.9h19.26Zm-19-.21h18.83v-12.4H618.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M637.66,232.53H618.4v-92h19.26Zm-19-.22h18.83V140.75H618.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 553.13,
    y: 246.17,
    width: 90.01,
    height: 26.73,
    rx: 1.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M616.42,246.07l-81.3.1a2.46,2.46,0,0,0-2.47,2.44v21.86a2.45,2.45,0,0,0,2.47,2.44c13.47,0,65.69.18,81.3.21a2.45,2.45,0,0,0,2.49-2.44V248.51A2.46,2.46,0,0,0,616.42,246.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 537.23,
    y: 245.69,
    width: 103.32,
    height: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M559.64,253H538.08a1.74,1.74,0,0,1-1.74-1.74h0a1.74,1.74,0,0,1,1.74-1.75h21.56a1.75,1.75,0,0,1,1.75,1.75h0A1.75,1.75,0,0,1,559.64,253Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 631.1,
    cy: 233.6,
    r: 109.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 482.37,
    cy: 282.02,
    r: 85.91,
    transform: "translate(-58.14 423.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 337.3,
    cy: 300.49,
    r: 76.3,
    transform: "translate(-113.69 326.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M646.55,156.05l-.15-.16c-21.22,22.73-55.08,41.35-91.31,49.29,0,2.42-.07,15.83-.34,77.61-.37,82.43,78.07,122.71,90.25,128.89C609.22,266.85,637.25,179.25,646.55,156.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M646.55,156.05c-9.3,23.2-37.33,110.8-1.55,255.63,11.8-5.43,91.23-45.65,91.6-128.07.28-61.79.34-75.2.35-77.62C700.88,197.75,667.57,178.9,646.55,156.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M645,414.59l-1.13-.58a198.56,198.56,0,0,1-50.5-36.33c-27.49-27.57-41.35-59.49-41.19-94.9l.35-79.71,2-.45c35.15-7.7,68.78-25.83,90-48.52l1.92-2,2.08,2.23c21,22.85,54.32,41.23,89,49.16l2.05.47V206c0,2.42-.07,15.82-.35,77.61-.38,85.29-83.63,126.07-93.12,130.44ZM557.7,207.28l-.33,75.53c-.33,72.33,60.29,111.82,87.68,126,13.3-6.35,88.58-45.84,88.93-125.16.24-52.13.32-69.82.34-75.53-34-8.18-66.58-26.09-87.94-48.37C624.86,181.74,592.06,199.35,557.7,207.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M646.27,396.39l-2.55-.15a173.28,173.28,0,0,1-41.08-30C578.28,342,566,314,566.14,283l.3-68.25,2.3-.59c29.31-7.56,56-21.44,75.29-39.09l2.16-2,2.08,2.08-2,2.32,2.09-2.25C667.45,193,694,207,723.14,214.82l2.28.61-.3,68.24c-.14,31-12.67,58.88-37.23,82.91a174.53,174.53,0,0,1-40.2,29.08ZM572.56,219.47,572.27,283c-.12,29.29,11.55,55.82,34.69,78.86a167.2,167.2,0,0,0,38.19,28.21,167.83,167.83,0,0,0,38.44-27.87C707,339.35,718.85,312.93,719,283.65l.29-63.53c-28.25-7.89-54-21.53-73.18-38.68C626.82,198.4,600.9,211.82,572.56,219.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M609.53,271.61v54.1c0,6,73.55,6,73.55,0v-54.1ZM650,300.34v15.33a3.73,3.73,0,1,1-7.45,0V300.3a9,9,0,1,1,7.45,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M676.64,267.75H669.2v-3.64a22.89,22.89,0,0,0-45.78,0v3.64H616v-3.64a30.34,30.34,0,1,1,60.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M804.33,162.59l-1.43,1.59,10.26.14-1.28-10.18L810,156.29a20.18,20.18,0,0,0-31.63,16.38h8.35a11.88,11.88,0,0,1,17.65-10.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M812.92,185.73A20.18,20.18,0,0,0,818,172.55l-8.35,0A11.88,11.88,0,0,1,792,182.64l1.42-1.59-10.26-.14,1.28,10.18,1.92-2.15A20.34,20.34,0,0,0,812.92,185.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 788.73,
    cy: 320.35,
    r: 10.53,
    transform: "translate(-62.55 326.22) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M800.37,403.66a6.05,6.05,0,1,1-6-6.05A6.05,6.05,0,0,1,800.37,403.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 414.82,
    cy: 6.05,
    r: 6.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M503.77,335.68h0a2.83,2.83,0,0,1-2.83-2.83V302.48a2.83,2.83,0,0,1,2.83-2.83h0a2.84,2.84,0,0,1,2.84,2.83v30.37A2.84,2.84,0,0,1,503.77,335.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M485.76,317.66h0a2.83,2.83,0,0,1,2.83-2.83H519a2.83,2.83,0,0,1,2.83,2.83h0A2.84,2.84,0,0,1,519,320.5H488.59A2.84,2.84,0,0,1,485.76,317.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M736.84,68.18h0a2.56,2.56,0,0,1-2.55-2.56V38.23a2.55,2.55,0,0,1,2.55-2.55h0a2.55,2.55,0,0,1,2.56,2.55V65.62A2.56,2.56,0,0,1,736.84,68.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M720.59,51.93h0a2.56,2.56,0,0,1,2.56-2.56h27.39a2.55,2.55,0,0,1,2.55,2.56h0a2.55,2.55,0,0,1-2.55,2.55H723.15A2.56,2.56,0,0,1,720.59,51.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.07,418.37a9.21,9.21,0,1,1,9.21-9.2A9.21,9.21,0,0,1,306.07,418.37Zm0-15.87a6.67,6.67,0,1,0,6.67,6.67A6.67,6.67,0,0,0,306.07,402.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M639.11,817.84l-.91,1,6.54.09-.82-6.48-1.22,1.37a12.84,12.84,0,0,0-20.14,10.43h5.32a7.51,7.51,0,0,1,1.9-4.82A7.63,7.63,0,0,1,639.11,817.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M644.58,832.58a12.84,12.84,0,0,0,3.24-8.39H642.5a7.51,7.51,0,0,1-1.9,4.82,7.63,7.63,0,0,1-9.33,1.59l.91-1-6.54-.09.82,6.48,1.22-1.37A13,13,0,0,0,644.58,832.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1132.69,1316.63H6.35a6.35,6.35,0,1,1,0-12.69H1132.69a6.35,6.35,0,0,1,0,12.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M112,1301.61S-33,1218.74,23.5,1111.4,263,971.51,189.22,860.92c-64-96-109.23-184.56-43.31-261.77C248,479.57,558.34,623.63,769.27,542.65s448.07,140.74,215.46,316.7c-278.92,211-14.55,439.65-14.55,439.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 526.64,
    y: 1006.77,
    width: 57.96,
    height: 26.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 548.74,
    y: 773.78,
    width: 16.07,
    height: 241.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M549.72,976.79l13.4,7.08v22.79h-13.4S550.11,977.17,549.72,976.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 393.96,
    y: 1025.58,
    width: 50.36,
    height: 278.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 249.79,
    y: 1025.58,
    width: 152.79,
    height: 278.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391,1084.77H260.6v-48.45H391ZM262.35,1083H389.21v-45H262.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "366.9 1083.84 289.9 1083.84 293.89 1077.82 362.9 1077.82 366.9 1083.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391,1144.32H260.6v-48.46H391Zm-128.61-1.75H389.21v-45H262.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "366.9 1143.38 289.9 1143.38 293.89 1137.36 362.9 1137.36 366.9 1143.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391,1203.86H260.6V1155.4H391Zm-128.61-1.75H389.21v-45H262.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "366.9 1202.92 289.9 1202.92 293.89 1196.9 362.9 1196.9 366.9 1202.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391,1263.4H260.6v-48.46H391Zm-128.61-1.75H389.21v-45H262.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "366.9 1262.46 289.9 1262.46 293.89 1256.44 362.9 1256.44 366.9 1262.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 764.58,
    y: 1015.16,
    width: 50.36,
    height: 289.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 620.41,
    y: 1025.58,
    width: 152.79,
    height: 278.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M761.58,1084.77H631.23v-48.45H761.58ZM633,1083H759.84v-45H633Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "737.52 1083.84 660.52 1083.84 664.52 1077.82 733.53 1077.82 737.52 1083.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M761.58,1144.32H631.23v-48.46H761.58ZM633,1142.57H759.84v-45H633Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "737.52 1143.38 660.52 1143.38 664.52 1137.36 733.53 1137.36 737.52 1143.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M761.58,1203.86H631.23V1155.4H761.58ZM633,1202.11H759.84v-45H633Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "737.52 1202.92 660.52 1202.92 664.52 1196.9 733.53 1196.9 737.52 1202.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M761.58,1263.4H631.23v-48.46H761.58ZM633,1261.65H759.84v-45H633Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "737.52 1262.46 660.52 1262.46 664.52 1256.44 733.53 1256.44 737.52 1262.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 249.57,
    y: 1015.23,
    width: 523.64,
    height: 11.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "433.53 1013.06 395.46 1013.06 362.97 882.78 401.04 882.78 433.53 1013.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "430.89 1013.06 392.83 1013.06 360.33 882.78 398.4 882.78 430.89 1013.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "424.06 975.14 383.3 975.14 381.59 968.28 422.35 968.28 424.06 975.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 283.96,
    y: 835.33,
    width: 216.93,
    height: 132.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 291.55,
    y: 841.46,
    width: 201.75,
    height: 120.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 303.71,
    y: 849.83,
    width: 65.61,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 303.71,
    y: 858.62,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 303.71,
    y: 867.4,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 303.71,
    y: 876.18,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 319.37,
    y: 884.96,
    width: 54.83,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 319.37,
    y: 895.52,
    width: 49.95,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 303.71,
    y: 904.3,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 303.71,
    y: 913.08,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 303.71,
    y: 921.86,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 303.71,
    y: 930.64,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 325.22,
    y: 940.7,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 303.71,
    y: 950.77,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 402.27,
    y: 849.83,
    width: 65.61,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 402.27,
    y: 858.62,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 402.27,
    y: 867.4,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 402.27,
    y: 876.18,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 417.93,
    y: 884.96,
    width: 54.83,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 417.93,
    y: 895.52,
    width: 49.95,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 402.27,
    y: 904.3,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 402.27,
    y: 913.08,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 402.27,
    y: 921.86,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 402.27,
    y: 930.64,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 423.78,
    y: 940.7,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 402.27,
    y: 950.77,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 500.87,
    y: 835.29,
    width: 2.99,
    height: 132.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 350.01,
    y: 1009.86,
    width: 104.45,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "685.51 1013.06 647.44 1013.06 614.95 882.78 653.02 882.78 685.51 1013.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "682.88 1013.06 644.81 1013.06 612.32 882.78 650.38 882.78 682.88 1013.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "676.04 975.14 635.28 975.14 633.57 968.28 674.33 968.28 676.04 975.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 535.94,
    y: 835.33,
    width: 216.93,
    height: 132.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 543.53,
    y: 841.46,
    width: 201.75,
    height: 120.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M658.92,937.82H575.78V878.44H616l16.37-12.31h85.85V928.9H670.63Zm-81.23-1.91h80.58L670,927H716.3V868H633l-16.37,12.31H577.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "613.27 869.91 605.26 876.58 576.16 876.58 584.2 869.91 613.27 869.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "623.24 869.91 614.38 876.58 608.21 876.58 616.05 869.91 623.24 869.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "672.45 931.49 665.32 936.87 718.04 936.87 718.04 931.63 672.45 931.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "713.7 923.67 713.31 923.67 713.31 871.32 634.68 871.32 634.68 870.93 713.7 870.93 713.7 923.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 583.61,
    y: 886.37,
    width: 6.35,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 592.95,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 596.52,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 600.1,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 603.67,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 607.25,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 610.83,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 614.4,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 617.98,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 621.56,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 625.13,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 628.71,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 632.29,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 635.86,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 639.44,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 643.01,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 646.59,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 650.17,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 653.74,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 657.32,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 660.9,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 664.47,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 668.05,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 671.62,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 675.2,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 678.78,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 682.35,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 685.93,
    y: 886.37,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 583.61,
    y: 895.42,
    width: 6.35,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 592.95,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 596.52,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 600.1,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 603.67,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 607.25,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 610.83,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 614.4,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 617.98,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 621.56,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 625.13,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 628.71,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 632.29,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 635.86,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 639.44,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 643.01,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 646.59,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 650.17,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 653.74,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 657.32,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 660.9,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 664.47,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 668.05,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 671.62,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 675.2,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 678.78,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 682.35,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 685.93,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 689.6,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 693.18,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 696.75,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 700.33,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 703.91,
    y: 895.42,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 583.61,
    y: 910.31,
    width: 6.35,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 592.95,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 596.52,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 600.1,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 603.67,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 607.25,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 610.83,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 614.4,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 617.98,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 621.56,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 625.13,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 628.71,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 632.29,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 635.86,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 639.44,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 643.01,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 646.59,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 650.17,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 653.74,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 657.32,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 660.9,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 664.47,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 668.05,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 671.62,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 675.2,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 678.78,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 682.35,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 685.93,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 689.6,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 693.18,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 696.75,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 700.33,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 703.91,
    y: 910.31,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 583.61,
    y: 919.84,
    width: 6.35,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 592.95,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 596.52,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 600.1,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 603.67,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 607.25,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 610.83,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 614.4,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 617.98,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 621.56,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 625.13,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 628.71,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 632.29,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 635.86,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 639.44,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 643.01,
    y: 919.84,
    width: 2.73,
    height: 5.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 752.85,
    y: 835.29,
    width: 2.99,
    height: 132.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 601.99,
    y: 1009.86,
    width: 104.45,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 283.7,
    y: 693.56,
    width: 469.54,
    height: 132.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 291.29,
    y: 699.69,
    width: 454.35,
    height: 120.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 401.87,
    y: 708.07,
    width: 65.61,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 401.87,
    y: 716.85,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 401.87,
    y: 725.63,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 401.87,
    y: 734.42,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 417.53,
    y: 743.2,
    width: 54.83,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 417.53,
    y: 753.76,
    width: 49.95,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 401.87,
    y: 762.54,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 401.87,
    y: 771.32,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 401.87,
    y: 780.1,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 401.87,
    y: 788.88,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 423.38,
    y: 798.94,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 401.87,
    y: 809,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.17,
    y: 708.07,
    width: 65.61,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.17,
    y: 716.85,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.17,
    y: 725.63,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.17,
    y: 734.42,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 328.83,
    y: 743.2,
    width: 54.83,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 328.83,
    y: 753.76,
    width: 49.95,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.17,
    y: 762.54,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.17,
    y: 771.32,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.17,
    y: 780.1,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.17,
    y: 788.88,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 334.69,
    y: 798.94,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 313.17,
    y: 809,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 500.43,
    y: 708.07,
    width: 65.61,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 500.43,
    y: 716.85,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 500.43,
    y: 725.63,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 500.43,
    y: 734.42,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 516.09,
    y: 743.2,
    width: 54.83,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 516.09,
    y: 753.76,
    width: 49.95,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 500.43,
    y: 762.54,
    width: 50.15,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 500.43,
    y: 771.32,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 500.43,
    y: 780.1,
    width: 48.51,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 500.43,
    y: 788.88,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 521.94,
    y: 798.94,
    width: 59.97,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 500.43,
    y: 809,
    width: 70.49,
    height: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 753.22,
    y: 693.53,
    width: 2.99,
    height: 132.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 605.26,
    y: 708.08,
    width: 61.4,
    height: 60.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 676.12,
    y: 708.08,
    width: 51.93,
    height: 104.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 609.27,
    y: 718.98,
    width: 53.37,
    height: 45.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 680.14,
    y: 717.83,
    width: 43.9,
    height: 89.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M513,1304.09c2.09-4.29,4.8-17.29-1.22-20.35-8.49-4.33-43.11,3.59-43.11,3.59s-1.94,11.63-2.91,16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M483.32,1136.08c0,1.63-14.74,150.3-14.74,150.3,1.05,7.74,24.26,2.54,30.16-.66l45.84-149.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M450.12,911.63,471.41,874c4.23-14.16,41-3.1,36.81,11.06l-5.48,42.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M566.56,1304.42c.57-3.51.76-13.11-5.22-18.18-8.27-7-20.47-1.71-20.47-1.71l-32.69-.33s-3.45,13.14-2.55,20.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M399.38,1079s-25.64,74.38,94,70.1c67.54-2.56,65.9-10.2,65.9-10.2l-47.45,146.56c2.71,5.66,25.67,5,32.29.59,0,0,84.33-137,80.06-168.58S564.38,1079,531,1078.11,399.38,1079,399.38,1079Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M535.39,1080c-41.79,51.76-156.54,46.15-155,3,0,0,2.42-105.26,37.4-159.88,12.4-19.37,27.66-27.92,49.59-27.6,22.53.33,45.89,19.82,52.65,34.73,1.7,3.76,3.52,15.16,5.28,30.1,3.64,30.66,7,76.28,8.8,101.42C534.93,1072.85,535.39,1080,535.39,1080Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M534.15,1061.7c-33.71-20.81-48.86-100.65-48.86-100.65l40.06-.77C529,990.94,532.4,1036.56,534.15,1061.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M523.57,828.6c8.34,18.87,4.12,47.25-9.72,54.32-19.48,8.57-50.39.48-60.84-23.29s-3.13-50,16.36-58.55S513.08,804.85,523.57,828.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M595.76,1001.19a35.54,35.54,0,0,1,19.54-7.77c12-.95,22.49,21.85,22.49,21.85H596.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M618.48,993.7s18.86,5.33,21.49,6c1.23,5-11.75,2.83-17.75.62C615.6,997.91,618.48,993.7,618.48,993.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M478.78,943.1s25.57,80.3,57.6,80.3,68.74-7.95,68.74-7.95c8.06-.91,4.93-23-1.13-23.94l-56.26-6.28s-11.91-50.26-42.39-71C483.53,910.12,471.85,927.52,478.78,943.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M603.93,992l-55.86-6.38-.1-.33c-16.14-51.48-38.87-69.65-39.1-69.82l.65-.84c.22.18,23.11,18.43,39.35,70l55.18,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M474.26,888.6c-5.58-.8-14.57-11-23.89-32.63-10.76-25-3.57-46.46,19.54-59.36,22.78-12.72,49,6.45,49.93,28.81C517.18,861.92,493.23,891.3,474.26,888.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M518.33,851.44c.62,4.81-1.24,9-4.14,9.38s-5.76-3.22-6.38-8,1.24-9,4.14-9.39S517.71,846.63,518.33,851.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M476.3,793.86s10.16,43.71,56.84,28.36C514.66,782.28,476.3,793.86,476.3,793.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M449.78,900.73l7.27-12.49c2-7.07,53.42,7.46,51.42,14.53l.58,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M508.28,915.16l-.12,0c-30.55-15.36-55.22-17.58-55.46-17.6a.27.27,0,0,1-.24-.28.27.27,0,0,1,.28-.23c.25,0,25,2.24,55.65,17.65a.25.25,0,0,1,.12.34A.28.28,0,0,1,508.28,915.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M391.21,1000.76l-1.87-.33c.1-.58,10.67-58.44,34.83-87.23,13-13.44,25.29-16.51,27.93-17l4.09-8.35a.57.57,0,0,1,.08-.13c.08-.11,1.9-2.55,7.19-2.31.66-1.08,1.12-1.75,1.42-2.18-3-3.92-19.27-25.8-20.45-43.86-.79-12.16,4.22-25.43,13.06-34.63,8.68-9,20.42-13.6,33.95-13.26l-.05,1.9c-13-.36-24.23,4-32.52,12.67s-13.28,21.73-12.54,33.2c1.24,18.9,20.3,43.14,20.49,43.38a1,1,0,0,1-.07,1.27h0a28.29,28.29,0,0,0-2,3,.94.94,0,0,1-.89.45c-4.17-.33-5.77,1.17-6,1.45l-4.25,8.67a1,1,0,0,1-.71.53c-.14,0-13.5,2.22-27.3,16.51C401.79,942.82,391.31,1000.19,391.21,1000.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M559.32,1138.87c-12.87-.07-60.61,12.43-67.65,0S469.08,973,469.08,973a17.35,17.35,0,0,0-17.19-15H296a19.32,19.32,0,0,0-19.19,21.91L299,1142.38a40.52,40.52,0,0,0,40.15,35h59v.07H580v-18C580,1148.12,572.2,1138.93,559.32,1138.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M501.05,1177.43H339.16a40.52,40.52,0,0,1-40.15-35L276.85,979.93A19.32,19.32,0,0,1,296,958H425.62a17.35,17.35,0,0,1,17.19,15c9.37,82.84,16.32,149.16,26.37,188.57C473.24,1177.53,492.26,1177.43,501.05,1177.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M338.23,1177.44c0,.12-.15.24-.15.37,0,7.9,49.59,14.31,110.75,14.31s110.75-6.41,110.75-14.31c0-.13-.12-.25-.14-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M534.48,1276.25c0-.12.12-.24.12-.37,0-7.9-39.09-14.31-87.31-14.31S360,1268,360,1275.88c0,.13.09.25.11.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 439.82,
    y: 1188.26,
    width: 19.32,
    height: 81.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 506.57,
    y: 1274.45,
    width: 9.84,
    height: 18.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 443.98,
    y: 1274.45,
    width: 9.84,
    height: 18.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 368.65,
    y: 1274.45,
    width: 9.84,
    height: 18.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 376.02,
    cy: 1292.71,
    rx: 7.51,
    ry: 11.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 383.29,
    cy: 1292.71,
    rx: 7.51,
    ry: 11.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M386.19,1303.62c-3.13,2.44-11.86,1.33-13.08.07l-.05-21.89c2.34-2.06,10.6-2,13.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M389.14,1292.39c0,4.49-2.3,8.13-5.14,8.13s-5.15-3.64-5.15-8.13,2.31-8.14,5.15-8.14S389.14,1287.9,389.14,1292.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M386.59,1292.62c0,2.74-1.4,5-3.14,5s-3.13-2.22-3.13-5,1.4-5,3.13-5S386.59,1289.88,386.59,1292.62Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 447.42,
    cy: 1292.71,
    rx: 7.51,
    ry: 11.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 440.15,
    cy: 1292.71,
    rx: 7.51,
    ry: 11.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M437.25,1303.62c3.12,2.44,11.86,1.33,13.08.07l.05-21.89c-2.34-2.06-10.61-2-13.12-.12Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 439.44,
    cy: 1292.39,
    rx: 5.14,
    ry: 8.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M436.85,1292.62c0,2.74,1.4,5,3.13,5s3.14-2.22,3.14-5-1.41-5-3.14-5S436.85,1289.88,436.85,1292.62Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 511.17,
    cy: 1292.71,
    rx: 7.51,
    ry: 11.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 503.89,
    cy: 1292.71,
    rx: 7.51,
    ry: 11.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M501,1303.62c3.12,2.44,11.85,1.33,13.07.07l.06-21.89c-2.35-2.06-10.61-2-13.13-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M498,1292.39c0,4.49,2.3,8.13,5.14,8.13s5.15-3.64,5.15-8.13-2.31-8.14-5.15-8.14S498,1287.9,498,1292.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M500.59,1292.62c0,2.74,1.41,5,3.14,5s3.13-2.22,3.13-5-1.4-5-3.13-5S500.59,1289.88,500.59,1292.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M209.17,1045.89c6.89,7.11-3.19,15.87-3.11,27.28s13.86,15.58,2.74,32.36c-6.85,10.34-15.84-.42-20.34,14.44s1.2,16.31-5.59,22.5c-11.84,10.81-35.25-4.92-30.69-19.77s18.56-15.9,10.32-26.15-11.41-14.72-1.36-22.34c12.44-9.43,25.54-4.8,24.9-15.5S200.05,1036.49,209.17,1045.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M167.91,1158.81l-2.37-.07c1.82-56.07,31.18-99.94,31.48-100.38l2,1.33C198.69,1060.12,169.71,1103.46,167.91,1158.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M63.36,1020.86c-7.36,11,8,20.12,10.68,35.16s-14.86,17.91,3.84,37.33c11.51,12,15.06,5.91,16.74,29.46,1.49,20.73,19.37,3.57,29.26,16.94,12.76,17.24,40.34-13.22,30.74-31.67s-24-15.93-15.62-31.42,2.61-28.75-12.47-36.35c-18.66-9.41-27.88,6.08-29.63-8.15S73.09,1006.27,63.36,1020.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M145,1159.56c-15.74-72.48-64.36-122.49-64.85-123l2.26-2.23c.5.51,49.75,51.18,65.69,124.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M106.79,1157.72v63.79a46.79,46.79,0,0,0,46.79,46.79h0a46.78,46.78,0,0,0,46.78-46.79v-63.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 101.6,
    y: 1205.93,
    width: 5.19,
    height: 99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 200.36,
    y: 1205.93,
    width: 5.19,
    height: 99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 160.68,
    y: 1205.93,
    width: 5.19,
    height: 99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 101.6,
    y: 1268.3,
    width: 99,
    height: 5.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1010.7,958.47l-17,9.5-4.31-7.76,0-.05-30.49-54.9,0,0L943,888.5l-30.24-32C897.21,836.07,923.93,811.24,942,829c18.5,18.23,35.37,45.36,43.16,59.62,6.12,11.21,18.45,48,23.43,63.2l.19.58C1010,956.17,1010.7,958.47,1010.7,958.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1015.54,972.6l-7.45-22.12c-3.17,6-15.45,10.22-18.75,9.68,0,0,8.87,17,11.19,20S1014.37,980,1015.54,972.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M998.42,976.33c0,.16,0,.37,0,.53a15.08,15.08,0,0,0,6.39,13,1,1,0,0,0,.39.21c-5.35-1.79-7.92,5.35-5.35,7.4,7.38,6.48,19.84.42,21.39-4s-5.68-21-5.68-21C1011.32,968.13,999.24,967.2,998.42,976.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M998.39,976.86c-.76,8.61,6.52,13.12,6.65,13.17,4.54.44,6.19.38,10.5.93-2.64-1.73-8-6.11-4.82-12.92C1006.73,974.09,999.7,976.21,998.39,976.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M998.4,975.87c-2.09,6.92-2.87,17.07-1.74,21.72,0,0,4.31.78,4.94-7.47.16-2.14,1.06-6.73,3.36-8,7-3.47,8.59-7.27,6.61-10.81C1008.94,966.6,999.41,969.83,998.4,975.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1016.05,997.76c-3.83,2-13.76,5.55-15.09,4.2s7.14-8.35,12.09-8.8S1018,996.74,1016.05,997.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M958.82,905.24,943,888.5l3.43-33.33C948.55,874.84,952.78,891.39,958.82,905.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M873.08,797.16l6.31,25.36,1.14,4.71c1.28,6,40.84,3.44,38-3.56l-2.35-5.16L904,791.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M850,759.55c-3.36,28.12,5.82,49.86,29.56,46.34,19.76-2.92,42.06-13.63,42.76-46.69.44-21.06-16.37-38.07-36.35-38S852.92,734.68,850,759.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M862.64,1274.66c-2.35-2.5-13.44-2.53-14.45,1.15s.94,6.31-3.74,12.15c2.69.78,12.25.85,15.17,0S865,1277.15,862.64,1274.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M878.05,1290.92H856.61c-2-90.74-1.62-189.52-.9-263.91.26-26.64,1-40.12,5.83-56.11,9.76-32.3,55.64-22.36,58.9,6.92,1.35,16.24,10.66,48.12-19.37,155.81C900.75,1205,883.07,1237.71,878.05,1290.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M838.81,1289c4-.22,13.27-4,15-6.7,2.58,2.89,8,3.69,14.45,2.72,7.67-1.14,8.68-4.71,14.19-4.23,2.32,6.45,8,20.92,2.51,24.28H828.17C823.09,1300.42,823.23,1290.54,838.81,1289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M968.89,1275.37c-2.14-2.26-12.2-2.29-13.11,1.05s.85,5.72-3.39,11c2.44.7,11.1.77,13.76,0S971,1277.63,968.89,1275.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M902,977c4.38-33.45,63.89-30,67.85-.8,1.43,15.72,7.63,34.22-3.55,151,23.59,44.55,15.09,113.63,22.14,160.69.77,7.16-19.51,8.88-21.08,2.5-21.62-87.31-51.82-185.27-63-257.9C900.26,1006.12,899.85,993.56,902,977Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M947.18,1285.83c4.29-.23,10.63-5.82,12.52-8.68,2.79,3.12,8.11,7.32,15.12,6.27,8.28-1.23,9.37-5.08,15.31-4.57,2.5,7,8.6,22.58,2.72,26.21H933.19C927.71,1300.06,930.36,1287.5,947.18,1285.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M734.26,810.56l6.85-9.07c5.21,2.66,14,5.9,23.16,10.6l-10,15.95C746,821.14,738.9,814.87,734.26,810.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M760.48,810.34l56.83,15.82L885.84,823c17.6-1.11,26.48,60.88-11.25,52.63l-50.15-15.57s-51-16-70.17-32.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M722.3,810.61c-3.34-7.17,3.25-16.54,3.75-17.25l14.68,7.91c7.37,3.65,3.38,13-4.78,13.85C736,815.12,725.83,817.11,722.3,810.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M725.22,799c-14.93-10.93-11.15-13.35-11.15-13.35s5.57,3.21,15.14,9.45C734.51,798.88,729.16,801.29,725.22,799Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M856.18,877.27c-3.76-18.3-5.78-36.38,13.09-47.74,5.38-17.54,53.86-27.66,64-6,16.94,7.57,13.27,40.59,16.45,92.73,11.67,26,16.74,34.57,20.2,59.92,0,0-6.24,19.09-50.24,19.12-20,0-49.4-1.77-62.78-12,1.33-17.28,8.56-33.93,11.57-58.4C868.42,925,856.45,879.37,856.18,877.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M851.16,767.09s-8.71,6-4.08,9.8,8.17,1,8.17,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 863.68,
    y: 1084.27,
    width: 100.47,
    height: 1.58,
    transform: "translate(-368.82 1691.02) rotate(-75.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M852,745.67s11.67,56.4,55.32,54.07c22.41-23.86,28.81-71.37-5.82-81.48C863.34,707.11,851.71,738.07,852,745.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "848.49 750.03 845.46 768.78 847.02 769.22 849.98 750.41 848.49 750.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M869.17,780.18a.53.53,0,0,1-.07-1c2-.3,3.77-2.37,4.29-5a6.23,6.23,0,0,0-2.68-6.75c-3.08-1.81-22.63-6.45-22.82-6.5a.51.51,0,0,1-.39-.63.52.52,0,0,1,.63-.39c.81.19,19.9,4.72,23.12,6.61a7.25,7.25,0,0,1,3.17,7.87c-.61,3.15-2.69,5.51-5.17,5.88Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 865.3,
    cy: 771.47,
    rx: 7.41,
    ry: 5.34,
    transform: "translate(-203.94 1219.4) rotate(-64.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M910.59,742.45s-6-2.86-3.14-10.42,16.85-6.28,18,1.43-2,7.13-2,7.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M909.75,737.15S925.9,813.88,920,912.8c.68,19.79,47.19,18.19,46.51-1.61,0,0-3.87-125.58-45.74-178.61C920.77,732.58,913.65,728.63,909.75,737.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M436.32,645a2.23,2.23,0,0,1-2.23-2.23V642a2.23,2.23,0,0,1,4.46,0v.72A2.23,2.23,0,0,1,436.32,645Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,0,1,4.46,0v.72A2.23,2.23,0,0,1,436.32,626.12Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,0,1,4.46,0V605A2.23,2.23,0,0,1,436.32,607.26Zm0-18.87a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,436.32,588.39Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,0,1,4.46,0v.73A2.23,2.23,0,0,1,436.32,569.53Zm0-18.86a2.24,2.24,0,0,1-2.23-2.23v-.73a2.23,2.23,0,0,1,4.46,0v.73A2.24,2.24,0,0,1,436.32,550.67Zm0-18.87a2.24,2.24,0,0,1-2.23-2.23v-.73a2.23,2.23,0,0,1,4.46,0v.73A2.24,2.24,0,0,1,436.32,531.8Zm0-18.87a2.23,2.23,0,0,1-2.23-2.23V510a2.23,2.23,0,0,1,4.46,0v.72A2.23,2.23,0,0,1,436.32,512.93Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,0,1,4.46,0v.72A2.23,2.23,0,0,1,436.32,494.07Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,0,1,4.46,0V473A2.23,2.23,0,0,1,436.32,475.21Zm0-18.87a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,0,1,4.46,0v.72A2.23,2.23,0,0,1,436.32,456.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M436.32,663.48a2.23,2.23,0,0,1-2.23-2.23,2.39,2.39,0,0,1,2.23-2.41,2.09,2.09,0,0,1,2.23,2v.36A2.23,2.23,0,0,1,436.32,663.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M646,437.48a2.23,2.23,0,0,1-2.23-2.24,2.38,2.38,0,0,1,2.23-2.4,2.09,2.09,0,0,1,2.23,2.05v.35A2.24,2.24,0,0,1,646,437.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M646,645a2.23,2.23,0,0,1-2.23-2.23V642a2.23,2.23,0,0,1,4.46,0v.73A2.23,2.23,0,0,1,646,645Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,0,1,4.46,0v.73A2.24,2.24,0,0,1,646,626.12Zm0-18.86a2.23,2.23,0,0,1-2.23-2.24v-.73a2.23,2.23,0,0,1,4.46,0V605A2.24,2.24,0,0,1,646,607.26Zm0-18.87a2.23,2.23,0,0,1-2.23-2.24v-.72a2.23,2.23,0,0,1,4.46,0v.72A2.24,2.24,0,0,1,646,588.39Zm0-18.87a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,646,569.52Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,0,1,4.46,0v.72A2.23,2.23,0,0,1,646,550.66Zm0-18.87a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,646,531.79Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23V510a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,646,512.93Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,1,1,4.46,0v.73A2.23,2.23,0,0,1,646,494.07Zm0-37.73a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,1,1,4.46,0v.73A2.24,2.24,0,0,1,646,456.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M646,663.47a2.23,2.23,0,0,1-2.23-2.23,2.38,2.38,0,0,1,2.23-2.4,2.09,2.09,0,0,1,2.23,2v.35A2.23,2.23,0,0,1,646,663.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M506.2,437.48a2.23,2.23,0,0,1-2.23-2.23,2.4,2.4,0,0,1,2.23-2.42,2.09,2.09,0,0,1,2.23,2.05v.37A2.23,2.23,0,0,1,506.2,437.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M506.2,645a2.23,2.23,0,0,1-2.23-2.23V642a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,506.2,645Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,506.2,626.11Zm0-37.73a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,0,1,4.46,0v.72A2.23,2.23,0,0,1,506.2,588.38Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,0,1,4.46,0v.73A2.23,2.23,0,0,1,506.2,569.52Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,1,1,4.46,0v.73A2.23,2.23,0,0,1,506.2,550.66Zm0-18.87a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,0,1,4.46,0v.73A2.23,2.23,0,0,1,506.2,531.79Zm0-18.86a2.24,2.24,0,0,1-2.23-2.24V510a2.23,2.23,0,0,1,4.46,0v.72A2.24,2.24,0,0,1,506.2,512.93Zm0-18.87a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,0,1,4.46,0v.72A2.23,2.23,0,0,1,506.2,494.06Zm0-18.86A2.23,2.23,0,0,1,504,473v-.73a2.23,2.23,0,1,1,4.46,0V473A2.23,2.23,0,0,1,506.2,475.2Zm0-18.87A2.23,2.23,0,0,1,504,454.1v-.72a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,506.2,456.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M506.2,663.48a2.23,2.23,0,0,1-2.23-2.23,2.39,2.39,0,0,1,2.23-2.41,2.09,2.09,0,0,1,2.23,2v.36A2.23,2.23,0,0,1,506.2,663.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M576.08,437.48a2.24,2.24,0,0,1-2.23-2.24,2.4,2.4,0,0,1,2.23-2.41,2.09,2.09,0,0,1,2.23,2.06v.35A2.24,2.24,0,0,1,576.08,437.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M576.08,645a2.23,2.23,0,0,1-2.23-2.23V642a2.23,2.23,0,1,1,4.46,0v.73A2.23,2.23,0,0,1,576.08,645Zm0-18.86a2.24,2.24,0,0,1-2.23-2.23v-.73a2.23,2.23,0,1,1,4.46,0v.73A2.24,2.24,0,0,1,576.08,626.12Zm0-18.86a2.24,2.24,0,0,1-2.23-2.24v-.73a2.23,2.23,0,1,1,4.46,0V605A2.24,2.24,0,0,1,576.08,607.26Zm0-18.87a2.24,2.24,0,0,1-2.23-2.24v-.72a2.23,2.23,0,0,1,4.46,0v.72A2.24,2.24,0,0,1,576.08,588.39Zm0-18.87a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,576.08,569.52Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,576.08,550.66Zm0-18.87a2.23,2.23,0,0,1-2.23-2.23v-.72a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,576.08,531.79Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23V510a2.23,2.23,0,1,1,4.46,0v.72A2.23,2.23,0,0,1,576.08,512.93Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.73a2.23,2.23,0,1,1,4.46,0v.73A2.23,2.23,0,0,1,576.08,494.07Zm0-18.86a2.23,2.23,0,0,1-2.23-2.23v-.74a2.23,2.23,0,1,1,4.46,0V473A2.23,2.23,0,0,1,576.08,475.21Zm0-18.87a2.24,2.24,0,0,1-2.23-2.23v-.73a2.23,2.23,0,1,1,4.46,0v.73A2.24,2.24,0,0,1,576.08,456.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M576.08,663.48a2.23,2.23,0,0,1-2.23-2.23,2.39,2.39,0,0,1,2.23-2.41,2.09,2.09,0,0,1,2.23,2v.36A2.23,2.23,0,0,1,576.08,663.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "444.76 434.22 436.97 429.32 429.31 434.22 429.31 431.57 437.03 426.67 444.76 431.57 444.76 434.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "444.76 440.14 436.97 435.24 429.31 440.14 429.31 437.49 437.03 432.59 444.76 437.49 444.76 440.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "499.25 603.5 507.04 608.41 514.7 603.5 514.7 606.15 506.98 611.06 499.25 606.15 499.25 603.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "499.25 597.58 507.04 602.49 514.7 597.58 514.7 600.23 506.98 605.14 499.25 600.23 499.25 597.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "653.42 475.01 645.63 470.11 637.97 475.01 637.97 472.36 645.69 467.46 653.42 472.36 653.42 475.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "653.42 480.94 645.63 476.03 637.97 480.94 637.97 478.29 645.69 473.38 653.42 478.29 653.42 480.94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBackupService);
export default __webpack_public_path__ + "static/media/cloud-backup-service.e88c69ccb35f3effb6e6cd2d3fe1febf.svg";
export { ForwardRef as ReactComponent };